// extracted by mini-css-extract-plugin
module.exports = {"guide":"ConfirmOffer_guide__1vZNi","intro":"ConfirmOffer_intro__U79v2","intro_1":"ConfirmOffer_intro_1__3JwRj"};